/* src/app/views/privacy/privacy.component.css */
/*# sourceMappingURL=privacy.component.css.map */
